import moment from 'moment';

const formatter = {
  toAmountDisplay(amount, noCents) {
    if (amount === null || typeof amount === "undefined") {
      return amount;
    }
    if (isNaN(parseFloat(amount))) {
        return amount;
    }
    amount = parseFloat(amount).toFixed(2);
    let commaAmount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (noCents === true) {
      commaAmount = commaAmount.indexOf('.') !== -1 ? commaAmount.split('.')[0] : commaAmount;
    } else {
      commaAmount = commaAmount.indexOf('.') === -1 ? `${commaAmount}.00` : commaAmount;
    }
    return `$${commaAmount}`;
  },

  toFixedNumber(num, digits, base){
    const pow = Math.pow(base || 10, digits);
    return Math.round(num*pow) / pow;
  },

  toDateDisplay(dateString, options={ noDay: false, fullMonth: false }) {
    if (!dateString) return null;

    const momentDate = moment(dateString);

    if (options.noDay) return momentDate.format('MMMM, YYYY')
    if (options.fullMonth) return momentDate.format('MMMM DD, YYYY');

    return momentDate.format('MMM DD, YYYY');
  },
};

export default formatter;
